import { LawWorksChargesTable } from "@/components/features/lawworks-charges/LawWorksChargesTable";
import { Text } from "@/components/ui";
import { retrieveFirmLawWorksChargesQueryOptions } from "@/lib/data/react-query/firm/lawworks-charges";
import { retrieveMatterLawWorksChargesQueryOptions } from "@/lib/data/react-query/matters/lawworks-charges";
import { tanstackTableNames } from "@/lib/data/static/tanstack-table-names";
import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";

type LawWorksChargesPageProps = { matterId?: never } | { matterId: string };

export function LawWorksChargesPage() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <Text variant="title">Charges</Text>
      <LawWorksChargesContent />
    </div>
  );
}

export function MatterLawWorksChargesSection({
  matterId,
}: {
  matterId: string;
}) {
  return <LawWorksChargesContent matterId={matterId} />;
}

function LawWorksChargesContent({ matterId }: LawWorksChargesPageProps) {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const query = useQuery(
    matterId
      ? retrieveMatterLawWorksChargesQueryOptions({
          matterId,
          pageNumber: pageIndex + 1,
          pageSize,
        })
      : retrieveFirmLawWorksChargesQueryOptions({
          pageNumber: pageIndex + 1,
          pageSize,
        }),
  );
  const charges = useMemo(() => query.data?.data ?? [], [query.data?.data]);
  const totalCount = query.data?.pagination?.count ?? 0;

  return (
    <LawWorksChargesTable
      charges={charges}
      isError={query.isError}
      isFetching={query.isFetching}
      isLoading={query.isLoading}
      pageIndex={pageIndex}
      pageSize={pageSize}
      totalCount={totalCount}
      tableName={
        matterId
          ? tanstackTableNames.matterLawWorksCharges
          : tanstackTableNames.firmLawWorksCharges
      }
      onPaginationChange={(nextPageIndex, nextPageSize) => {
        setPageIndex(nextPageIndex);
        setPageSize(nextPageSize);
      }}
    />
  );
}
